module.exports = __webpack_public_path__ + "static/media/toolkit.dc71e5f5.png";